<template>
  <transition name="sj-notify-fade">
    <!-- notify位置根据notify数量计算得出 -->
    <div
      v-show="visibleData"
      class="
        sj-notify
        right
      "
      :style="positionStyle"
    >
      <i class="sj-notify-icon icon_com" :class="[`comalert_${type}`]"></i>
      <div class="sj-notify-content" v-if="!html">
        <div>{{ message }}</div>
        <div class="sj-notify-content-sub" v-if="subMessage">
          {{ subMessage }}
        </div>
      </div>
      <div v-else>
        <div v-html="message"></div>
        <div
          class="sj-notify-content-sub"
          v-if="subMessage"
          v-html="subMessage"
        ></div>
      </div>
      <div
        class="sj-notify-close-box"
        :class="{ showClose: showClose }"
        v-if="showClose"
      >
        <i
          class="sj-notify-close icon_com commulti_close"
          @click.stop="close"
        ></i>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * messagebox组件，使用了utils中的popup mixin作为基础
 * 此弹窗为非屏蔽式弹窗，用于操作反馈等提示
 *
 * 组件注册至vue实例，参见index.js
 * 组件在index.js中保存数据，记录显示位置
 */
import Popup from "../../../utils/popup/index.js";

export default {
  name: "SjNotify",
  mixins: [Popup],
  data() {
    return {
      message: "",
      subMessage: "",
      type: "info",
      duration: 4500,
      showClose: false,
      onClose: null,
      html: false,

      /**
       * 内部变量，不作为配置项
       */
      visibleData: false,
      verticalOffset: 0,
      closed: false,
      timer: null
    };
  },
  computed: {
    /**
     * 计算得到的notify位置样式
     */
    positionStyle() {
      return {
        top: `${this.verticalOffset}px`
      };
    }
  },
  mounted() {
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.close();
        }
      }, this.duration);
    }
  },
  methods: {
    close() {
      this.closed = true;
      if (typeof this.onClose === "function") {
        this.onClose();
      }
    },
    destroyElement() {
      this.$el.removeEventListener("transitionend", this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visibleData = false;
        this.$el.addEventListener("transitionend", this.destroyElement);
      }
    }
  }
};
</script>

<style lang="less">
@notify-max-width: 360px;
@notify-right: 16px;
@notify-padding: 20px;
@notify-border-radius: @base-border-radius;
@notify-box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
@notify-background-color: @color-antibg;
@notify-transition: opacity 0.3s, transform 0.3s, left 0.3s, right 0.3s,
  top 0.4s, bottom 0.3s;
@notify-item-space: 10px;

@notify-border: @base-border-width @base-border-style @color-gray-4;
@notify-hover-color: @color-gray-3;

@notify-close-top: 18px;
@notify-close-right: 15px;
@notify-close-font-size: 20px;

.sj-notify-fade-enter {
  &.right {
    right: 0;
    transform: translateX(100%);
  }

  &.left {
    left: 0;
    transform: translateX(-100%);
  }
}

.sj-notify-fade-leave-active {
  opacity: 0;
}

.sj-notify {
  display: flex;
  position: fixed;
  box-sizing: border-box;
  max-width: @notify-max-width;
  right: @notify-right;
  padding: @notify-padding;
  border-radius: @notify-border-radius;
  background-color: @notify-background-color;
  box-shadow: @notify-box-shadow;
  transition: @notify-transition;
  overflow: hidden;

  border: @notify-border;
  .text("body", "dark");

  .sj-notify-icon {
    top: @notify-close-top;
    right: @notify-close-right;
    font-size: @notify-close-font-size;
    margin-right: @notify-item-space;

    &.icon-info {
      color: @color-alert-info;
    }
    &.icon-success {
      color: @color-alert-success;
    }
    &.icon-error {
      color: @color-alert-error;
    }
    &.comalert_info {
      color: @color-alert-info;
    }
    &.comalert_success {
      color: @color-alert-success;
    }
    &.comalert_error {
      color: @color-alert-error;
    }
  }

  .sj-notify-content {
    .text("body", "dark");
    word-break: break-all;

    .sj-notify-content-sub {
      margin-top: 10px;
      .text("caption", "dark");
    }
  }
  .sj-notify-close-box {
    width: 20px;
    height: 20px;
    margin-left: @notify-item-space;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sj-notify-close {
    .text("body", "normal");
    padding: 0 4px;
  }
  .showClose:hover {
    background-color: @notify-hover-color;
  }
}
</style>
